<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
var hidden, visibilityChange;
import store from '@/store';
export default {
	name: 'App',
	// mounted() {
	// 	window.isCloseHint = true;
	// 	//初始化关闭
	// 	window.addEventListener("beforeunload", function(e) {
	// 		if (window.isCloseHint) {
	// 			var confirmationMessage = "要记得保存！你确定要离开我吗？";
	// 			(e || window.event).returnValue = confirmationMessage; // 兼容 Gecko + IE
	// 			return confirmationMessage; // 兼容 Gecko + Webkit, Safari, Chrome
	// 		}
	// 	});
	// },
	methods:{
		handleVisibilityChange(){
			if (document[hidden]) {
				this.$store.commit('app/SET_IS_SHOWtIPS',true);
				this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
					type:`坐席离开了ocs页面`
				})
			} else {
				this.$store.commit('app/SET_IS_SHOWtIPS',false);
				this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
					type:`坐席进入ocs页面`
				})
			}
		},
		handleCloseBrower(){
			let _beforeUnload_time = 0, _gap_time = 0;
			let api_url = '';
			let token = '';
			let that = this;
			let userInfo = {};
			  window.onunload = function (){
			   _gap_time = new Date().getTime() - _beforeUnload_time;
			   if(_gap_time <= 5){
			      // 刷新时onbeforeunload与onunload的时间差一般都远大于5
			     // 浏览器关闭
			     // localStorage.clear()
				 that.toCloseBrowser(api_url, token, userInfo)
			   } else {
			     // 浏览器刷新
			   }
			  }
			  window.onbeforeunload = function (){
			      // 刷新或关闭页面都会执行，且先于onunload执行
			      _beforeUnload_time = new Date().getTime();
				   api_url = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_BASE_API : window.location.origin;
					token = localStorage.getItem('access_token');
					userInfo = localStorage.getItem('GlobalUserInfo') ? JSON.parse(localStorage.getItem('GlobalUserInfo')) : {};
			  };
				
		},
		toCloseBrowser(api_url, token, userInfo){
			fetch(`${api_url}/ocs-auth/user/common/logout`,{
				method: "POST",
				headers: {
					"Authorization": token,
					// "Content-Type": "application/json;charset=utf-8"
				},
				keepalive: true,
				body: JSON.stringify({brand: userInfo?.brandIdentify,account: userInfo?.account,agentCode: userInfo?.agentCode})
			})
			
			localStorage.clear();
			
		}
	},
	mounted(){
		window.addEventListener('storage', function (e) {
			console.log(e)
			if(e.key && e.key == 'GlobalLogoutStatus' && e.newValue){
				const GlobalLogoutStatus = JSON.parse(localStorage.getItem('GlobalLogoutStatus'));
				if(GlobalLogoutStatus) {
					this.$store.dispatch('user/logout');
					localStorage.remove("GlobalLogoutStatus");
				}
			}
		});
		if (typeof document.hidden !== "undefined") {
		    hidden = "hidden";
		    visibilityChange = "visibilitychange"
		} else {
		    if (typeof document.msHidden !== "undefined") {
		        hidden = "msHidden";
		        visibilityChange = "msvisibilitychange"
		    } else {
		        if (typeof document.webkitHidden !== "undefined") {
		            hidden = "webkitHidden";
		            visibilityChange = "webkitvisibilitychange"
		        }
		    }
		}
		document.addEventListener(visibilityChange,this.handleVisibilityChange, false)
		this.handleCloseBrower()
	}
}
</script>
<style lang="scss">
*{
	padding: 0;
	margin: 0;
}
</style>